"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var UtilityHelper = function () {
    function UtilityHelper() {
        _classCallCheck(this, UtilityHelper);
    }

    _createClass(UtilityHelper, [{
        key: "getRootSiteUrl",
        value: function getRootSiteUrl() {
            if (window.location && window.location.origin) {
                return window.location.origin;
            } else if (window.location && window.location.protocol && window.location.host) {
                return window.location.protocol + "//" + window.location.host;
            }
        }
    }, {
        key: "getSiteLangCode",
        value: function getSiteLangCode(rootSiteUrl, DefaultWebLangCode) {
            var langCode = void 0;

            if (_spPageContextInfo.currentCultureName) langCode = _spPageContextInfo.currentCultureName;else {
                langCode = DefaultWebLangCode;

                if (window.location && window.location.href) {
                    var relativeUrl = window.location.href.substring(rootSiteUrl.length);

                    langCode = relativeUrl;
                    if (langCode.indexOf("/") == 0) {
                        langCode = langCode.substring(1, langCode.indexOf("/", 1));
                    } else {
                        langCode = langCode.substring(0, langCode.indexOf("/"));
                    }
                }
            }

            return langCode;
        }

        /**
         * Deprecated. Usar getWebApiPath("minhac.settings.ServiceUrl", "http://local.spservices.minhac.age", true)
         * @param {*} webApiServerHostUrl 
         */

    }, {
        key: "getWebApiHost",
        value: function getWebApiHost(webApiServerHostUrl) {

            var host = window.location.host;
            var schema = window.location.protocol;
            var url = "";
            var ret = "";

            if (window.minhac !== undefined) {
                if (window.minhac.settings !== undefined) {
                    if (window.minhac.settings.SPServicesUrl) {

                        var webApiHostUrl = window.minhac.settings.SPServicesUrl;

                        return webApiHostUrl;
                    }
                }
            }

            switch (host) {
                // Local
                case "devedispportal.minhac.age":
                case "devedispintranet.minhac.age":
                case "devedispsede.minhac.age":
                    url = "local.spservices.minhac.age";
                    ret = schema + "//" + url;
                    break;
                // DES EDI            
                case "desedispportal.minhac.age":
                case "desedispintranet.minhac.age":
                case "desedispportal.minhac.age":
                case "devaplicaciones.serviciosinternos.minhap.es":
                case "devapp.serviciosinternos.hacienda.gob.es":
                case "des.spservices.hacienda.gob.es":
                // DES PUB
                case "despubspportal.minhac.age":
                // INT EDI
                case "intapp.serviciosinternos.hacienda.gob.es":
                    url = "des.spservices.minhac.age";
                    ret = schema + "//" + url;
                    break;
                // PRE EDI
                case "preedispportal.minhac.age":
                case "prespswebedi2.minhac.age:8080":
                case "prespswebedi1.minhac.age:8080":
                case "portalpre.meh.age":
                case "preedispintranet.minhac.age":
                case "preaplicaciones.serviciosinternos.minhap.es":
                case "preapp.serviciosinternos.hacienda.gob.es":
                case "pre.spservices.hacienda.gob.es":
                case "pre.spservices.minhac.age":
                    url = "pre.spservices.minhac.age";
                    ret = schema + "//" + url;
                    break;
                // PRE PUB
                case "prespswebpub1.minhacdmz.age:8080":
                case "prespswebpub2.minhacdmz.age:8080":
                case "prepubspportal.minhacdmz.age":
                case "portalpre.minhafp.gob.es":
                case "portalpre.minhap.gob.es":
                case "portalpre.hacienda.gob.es":
                    url = "preserviciostelematicos.minhap.gob.es";
                    ret = schema + "//" + url;
                    break;
                // PRO EDI
                case "proedispportal.minhac.age":
                case "alcspswebedi1.minhac.age:8080":
                case "cdrspswebedi1.minhac.age:8080":
                case "www.meh.age":
                case "proedispintranet.minhac.age":
                case "intranet.minhac.age":
                case "aplicaciones.serviciosinternos.minhap.es":
                case "app.serviciosinternos.hacienda.gob.es":
                    url = "spservices.minhac.age";
                    ret = schema + "//" + url;
                    break;
                // PRO PUB
                case "proalcspportal.minhacdmz.age":
                case "alcspswebpub1.minhacdmz.age:8080":
                case "alcspswebpub2.minhacdmz.age:8080":
                case "www.minhafp.gob.es":
                case "www.minhap.gob.es":
                case "www.hacienda.gob.es":
                // PRO CDR
                case "procdrspportal.minhacdmz.age":
                case "cdrspswebpub2.minhacdmz.age:8080":
                case "cdrspswebpub1.minhacdmz.age:8080":
                    url = "serviciostelematicos.minhap.gob.es";
                    ret = schema + "//" + url;
                    break;
                default:
                    ret = webApiServerHostUrl;
                    break;
            }

            return ret;
        }

        /**
         * Deprecated. Usar getWebApiPath("minhac.settings.ServiceUrl", "http://local.spservices.hacienda.gob.es", false)
         * @param {*} webApiServerHostUrl Normalmente es el valor por defecto.
         */

    }, {
        key: "getWebApiHostHacienda",
        value: function getWebApiHostHacienda(webApiServerHostUrl) {

            var host = window.location.host;
            var schema = window.location.protocol;
            var url = "";
            var ret = "";

            if (window.minhac !== undefined) {
                if (window.minhac.settings !== undefined) {
                    if (window.minhac.settings.SPServicesUrlHacienda) {

                        var webApiHostUrl = window.minhac.settings.SPServicesUrlHacienda;

                        return webApiHostUrl;
                    }
                }
            }

            switch (host) {
                // Local
                case "devedispportal.minhac.age":
                case "devedispintranet.minhac.age":
                case "devedispsede.minhac.age":
                    url = "local.spservices.minhac.age";
                    ret = schema + "//" + url;
                    break;
                // DES EDI            
                case "desedispportal.minhac.age":
                case "desedispintranet.minhac.age":
                case "desedispportal.minhac.age":
                case "devaplicaciones.serviciosinternos.minhap.es":
                case "devapp.serviciosinternos.hacienda.gob.es":
                // DES PUB
                case "despubspportal.minhac.age":
                // INT EDI
                case "intapp.serviciosinternos.hacienda.gob.es":
                    url = "des.spservices.hacienda.gob.es";
                    ret = schema + "//" + url;
                    break;
                // PRE EDI
                case "preedispportal.minhac.age":
                case "prespswebedi2.minhac.age:8080":
                case "prespswebedi1.minhac.age:8080":
                case "portalpre.meh.age":
                case "preedispintranet.minhac.age":
                case "preaplicaciones.serviciosinternos.minhap.es":
                case "preapp.serviciosinternos.hacienda.gob.es":
                    url = "pre.spservices.hacienda.gob.es";
                    ret = schema + "//" + url;
                    break;
                // PRE PUB
                case "prespswebpub1.minhacdmz.age:8080":
                case "prespswebpub2.minhacdmz.age:8080":
                case "prepubspportal.minhacdmz.age":
                case "portalpre.minhafp.gob.es":
                case "portalpre.minhap.gob.es":
                case "portalpre.hacienda.gob.es":
                    url = "preserviciostelematicos.hacienda.gob.es";
                    ret = "https://" + url;
                    break;
                // PRO EDI
                case "proedispportal.minhac.age":
                case "alcspswebedi1.minhac.age:8080":
                case "cdrspswebedi1.minhac.age:8080":
                case "www.meh.age":
                case "proedispintranet.minhac.age":
                case "intranet.minhac.age":
                case "aplicaciones.serviciosinternos.minhap.es":
                case "app.serviciosinternos.hacienda.gob.es":
                    url = "spservices.hacienda.gob.es";
                    ret = "https://" + url;
                    break;
                // PRO PUB
                case "proalcspportal.minhacdmz.age":
                case "alcspswebpub1.minhacdmz.age:8080":
                case "alcspswebpub2.minhacdmz.age:8080":
                case "www.minhafp.gob.es":
                case "www.minhap.gob.es":
                case "www.hacienda.gob.es":
                // PRO CDR
                case "procdrspportal.minhacdmz.age":
                case "cdrspswebpub2.minhacdmz.age:8080":
                case "cdrspswebpub1.minhacdmz.age:8080":
                    url = "serviciostelematicos.hacienda.gob.es";
                    ret = schema + "//" + url;
                    break;
                default:
                    ret = webApiServerHostUrl;
                    break;
            }

            return ret;
        }

        /**
         * Esta función esta pensada para recuperar valores. Normalmente del tipo minhac.**.variable
         * El valor por defecto se usa para cuando la variable no esta definida.
         * @param {*} keyName 
         * @param {*} defaultValue 
         */

    }, {
        key: "getMinhacValue",
        value: function getMinhacValue(keyName, defaultValue) {
            var ret = defaultValue;

            var aux = this.getVariableValueOrUndefined(keyName);

            if (aux) {
                ret = aux;
            }

            return ret;
        }

        /**     
         * Esta función es la que debemos usar para recuperar la dirección del servicio 
         * a llamar. 
         * @param {*} variableName Nombre completo de la variable (minhac.settings.SPServiceUrl)
         * @param {*} defaultValue Valor por defecto. Normalmente el valor de localhost
         * @param {*} isSharePoint Esta variable determina si usamos los servicios web que estan en SharePoint o .Net
         */

    }, {
        key: "getWebApiPath",
        value: function getWebApiPath(variableName, defaultValue) {
            var isSharePoint = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;

            var webApiHostUrl = this.getVariableValueOrUndefined(variableName);

            // Si la variable existe la devolvemos tal cual. Para localhost podemos usar el fichero html para simular
            // el comportamiento del resto de entornos
            if (webApiHostUrl) {
                return webApiHostUrl;
            }

            var host = window.location.host;
            var schema = window.location.protocol;

            // El valor por defecto se devuelve cuando no se encuntra el host en la tabla de valores. La tabla
            // es el ultimo recurso. El valor por defecto puede ser usado para cuando pretendemos probar en localhost.
            if (isSharePoint) {
                webApiHostUrl = this.checkHaciendaHost(defaultValue, host, schema);
            } else {
                webApiHostUrl = this.checkMinhacHost(defaultValue, host, schema);
            }

            return webApiHostUrl;
        }
    }, {
        key: "getVariableValueOrUndefined",
        value: function getVariableValueOrUndefined(variableName) {
            variableName = variableName.split('.');
            var obj = window[variableName.shift()];
            while (obj && variableName.length) {
                obj = obj[variableName.shift()];
            }return obj;
        }
    }, {
        key: "checkHaciendaHost",
        value: function checkHaciendaHost(webApiServerHostUrl, host, schema) {
            var url = "";
            var ret = "";

            switch (host) {
                // Local
                case "devedispportal.minhac.age":
                case "devedispintranet.minhac.age":
                case "devedispsede.minhac.age":
                    url = "local.spservices.hacienda.gob.es";
                    ret = schema + "//" + url;
                    break;
                // DES EDI            
                case "desedispportal.minhac.age":
                case "desedispintranet.minhac.age":
                case "desedispportal.minhac.age":
                case "devaplicaciones.serviciosinternos.minhap.es":
                case "devapp.serviciosinternos.hacienda.gob.es":
                // DES PUB
                case "despubspportal.minhac.age":
                // INT EDI
                case "intapp.serviciosinternos.hacienda.gob.es":
                    url = "des.spservices.hacienda.gob.es";
                    ret = "https://" + url;
                    break;
                // PRE EDI
                case "preedispportal.minhac.age":
                case "prespswebedi2.minhac.age:8080":
                case "prespswebedi1.minhac.age:8080":
                case "portalpre.meh.age":
                case "preedispintranet.minhac.age":
                case "preaplicaciones.serviciosinternos.minhap.es":
                case "preapp.serviciosinternos.hacienda.gob.es":
                    url = "pre.spservices.hacienda.gob.es";
                    ret = "https://" + url;
                    break;
                // PRE PUB
                case "prespswebpub1.minhacdmz.age:8080":
                case "prespswebpub2.minhacdmz.age:8080":
                case "prepubspportal.minhacdmz.age":
                case "portalpre.minhafp.gob.es":
                case "portalpre.minhap.gob.es":
                case "portalpre.hacienda.gob.es":
                    url = "preserviciostelematicos.hacienda.gob.es";
                    ret = "https://" + url;
                    break;
                // PRO EDI
                case "proedispportal.minhac.age":
                case "alcspswebedi1.minhac.age:8080":
                case "cdrspswebedi1.minhac.age:8080":
                case "www.meh.age":
                case "proedispintranet.minhac.age":
                case "intranet.minhac.age":
                case "aplicaciones.serviciosinternos.minhap.es":
                case "app.serviciosinternos.hacienda.gob.es":
                    url = "spservices.hacienda.gob.es";
                    ret = "https://" + url;
                    break;
                // PRO PUB
                case "proalcspportal.minhacdmz.age":
                case "alcspswebpub1.minhacdmz.age:8080":
                case "alcspswebpub2.minhacdmz.age:8080":
                case "www.minhafp.gob.es":
                case "www.minhap.gob.es":
                case "www.hacienda.gob.es":
                // PRO CDR
                case "procdrspportal.minhacdmz.age":
                case "cdrspswebpub2.minhacdmz.age:8080":
                case "cdrspswebpub1.minhacdmz.age:8080":
                    url = "serviciostelematicos.hacienda.gob.es";
                    ret = schema + "//" + url;
                    break;
                default:
                    ret = webApiServerHostUrl;
                    break;
            }

            return ret;
        }
    }, {
        key: "checkMinhacHost",
        value: function checkMinhacHost(webApiServerHostUrl, host, schema) {
            var url = "";
            var ret = "";

            switch (host) {
                // Local
                case "devedispportal.minhac.age":
                case "devedispintranet.minhac.age":
                case "devedispsede.minhac.age":
                    url = "local.spservices.minhac.age";
                    ret = schema + "//" + url;
                    break;
                // DES EDI            
                case "desedispportal.minhac.age":
                case "desedispintranet.minhac.age":
                case "desedispportal.minhac.age":
                case "devaplicaciones.serviciosinternos.minhap.es":
                case "devapp.serviciosinternos.hacienda.gob.es":
                case "des.spservices.hacienda.gob.es":
                // DES PUB
                case "despubspportal.minhac.age":
                // INT EDI
                case "intapp.serviciosinternos.hacienda.gob.es":
                    url = "des.spservices.minhac.age";
                    ret = schema + "//" + url;
                    break;
                // PRE EDI
                case "preedispportal.minhac.age":
                case "prespswebedi2.minhac.age:8080":
                case "prespswebedi1.minhac.age:8080":
                case "portalpre.meh.age":
                case "preedispintranet.minhac.age":
                case "preaplicaciones.serviciosinternos.minhap.es":
                case "preapp.serviciosinternos.hacienda.gob.es":
                case "pre.spservices.hacienda.gob.es":
                case "pre.spservices.minhac.age":
                    url = "pre.spservices.minhac.age";
                    ret = schema + "//" + url;
                    break;
                // PRE PUB
                case "prespswebpub1.minhacdmz.age:8080":
                case "prespswebpub2.minhacdmz.age:8080":
                case "prepubspportal.minhacdmz.age":
                case "portalpre.minhafp.gob.es":
                case "portalpre.minhap.gob.es":
                case "portalpre.hacienda.gob.es":
                    url = "preserviciostelematicos.minhap.gob.es";
                    ret = schema + "//" + url;
                    break;
                // PRO EDI
                case "proedispportal.minhac.age":
                case "alcspswebedi1.minhac.age:8080":
                case "cdrspswebedi1.minhac.age:8080":
                case "www.meh.age":
                case "proedispintranet.minhac.age":
                case "intranet.minhac.age":
                case "aplicaciones.serviciosinternos.minhap.es":
                case "app.serviciosinternos.hacienda.gob.es":
                    url = "spservices.minhac.age";
                    ret = schema + "//" + url;
                    break;
                // PRO PUB
                case "proalcspportal.minhacdmz.age":
                case "alcspswebpub1.minhacdmz.age:8080":
                case "alcspswebpub2.minhacdmz.age:8080":
                case "www.minhafp.gob.es":
                case "www.minhap.gob.es":
                case "www.hacienda.gob.es":
                // PRO CDR
                case "procdrspportal.minhacdmz.age":
                case "cdrspswebpub2.minhacdmz.age:8080":
                case "cdrspswebpub1.minhacdmz.age:8080":
                    url = "serviciostelematicos.minhap.gob.es";
                    ret = schema + "//" + url;
                    break;
                default:
                    ret = webApiServerHostUrl;
                    break;
            }

            return ret;
        }
    }]);

    return UtilityHelper;
}();

exports.default = UtilityHelper;
var util = exports.util = new UtilityHelper();